import apiCall from "./apiCall";

export type InspectorPerson = {
    inspectorID: string | number,
    fullName: string,
    type: string,
    country: string,
    oil: boolean,
    chemicals: boolean,
    gas: boolean,
    status: boolean,
    uploadId: string,
    uriFile: string,
    created: string,
    createdBy: string,
    isDeleted: boolean,
    id: string,
    modified: string,
    modifiedBy: string,
};

const getListInspectorPerson = async (param: any) => {
    const query = `?search=${param.search}&status=${param.status}&type=${param.type}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/InspectorPersons/GetAllInspectorPersons${query}`;
    return apiCall('get', URL);
};

const getInspectorPersonById = async (id: string) => {
    const URL = `/InspectorPersons/GetInspectorPersonById/${id}`;
    return apiCall('get', URL);
};

const getInspectorPersonData = async (type = '') => {
    const URL = `/InspectorPersons/GetDataInspectorPerson?type=${type}`;
    return apiCall('get', URL);
};

const putInspectorPerson = async (data: any) => {
    const URL = '/InspectorPersons/Update';
    return apiCall('post', URL, data);
};

const postInspectorPerson = async (data: any) => {
    const URL = '/InspectorPersons/Create';
    return apiCall('post', URL, data);
};

const deleteInspectorPerson = async (data: any) => {
    const URL = '/InspectorPersons/Delete';
    return apiCall('post', URL, data);
};

export {
    deleteInspectorPerson,
    postInspectorPerson,
    putInspectorPerson,
    getInspectorPersonById,
    getListInspectorPerson,
    getInspectorPersonData
}